import Button from "./cta/Button";
import { OnboardConstants } from "../../constants/constants";
import AreYouSureIcon from "../../assets/images/AreYouSureIcon";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

interface ModalProps {
  popUpMsg: string;
  popUpTitle: string;
  popUpMsg2?: string | null;
  isOpen: boolean;
  buttonText1?: string;
  buttonText2?: string;
  onOkay: () => void;
  onCancel: () => void;
  icon?: any;
  isSucessMessage?:any;
}

const PopupModalWithCancelButton = ({
  popUpTitle,
  popUpMsg,
  popUpMsg2,
  isOpen,
  onOkay,
  onCancel,
  buttonText1 = OnboardConstants.Yes,
  buttonText2 = OnboardConstants.No,
  icon = <AreYouSureIcon />,
  isSucessMessage,
}: ModalProps) => {
  const { t, i18n } = useTranslation();
  return ReactDOM.createPortal(
    <>
      {isOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-8 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-blackColor bg-opacity-35 "></div>
            </div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div
              className="inline-block align-bottom bg-whiteColor w-[436px]  rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="flex flex-col mt-20 mb-10 items-center justify-center ">
                {icon}
                <div
                  className="text-popUpTitleColor mt-7 popUpModelWithcancelButton  text-center font-poppins"
                >
                  {popUpTitle}
                </div>
                <div className="placeHolderText text-popUpTitleColor font-nunito  text-center mt-5 px-7  ">
                  {" "}
                  {popUpMsg}
                </div>
                {popUpMsg2 && (
                  <div className="placeHolderText text-popUpTitleColor font-nunito  text-center  px-7  ">
                    {popUpMsg2}
                  </div>
                )}
                <div className="flex items-center mt-8 ">
                  <div className="pr-7">
                    <Button
                      handleClick={onCancel}
                      buttonText={t(buttonText2)}
                      className={
                        "py-3 px-9  mb-2 downloadSampleConsentText font-nunito text-primary border  border-primary bg-whiteColor rounded-lg"
                      }
                    />
                  </div>
                  <div>
                    <Button
                      buttonText={t(buttonText1)}
                      handleClick={onOkay}
                      className="py-3 px-8 mb-2 downloadSampleConsentText text-white font-nunito  bg-primary rounded-lg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};
export default PopupModalWithCancelButton;
